// @todo Remove when dependency for redux / saga / recompose has been deprecated

import { compose } from 'recompose'
import { connect } from 'react-redux'
import RemoteComplianceLocations from './components/table'

const mapStateToProps = (state) => ({
  companyId: state.account.company._id,
  tippedEmployees: state.account.company.hasTippedEmployees
})

const RemoteComplianceLocationsComponent = compose(connect(
  mapStateToProps
))(RemoteComplianceLocations)

export default RemoteComplianceLocationsComponent
